var map = {
	"./Alcohol.jpg": 83,
	"./Artificial Colour.jpg": 84,
	"./Bakeable Fillings.jpg": 85,
	"./Bakery Glaze.jpg": 86,
	"./Bakery Glaze1.jpg": 87,
	"./Baking Powder.jpg": 88,
	"./Berry.jpg": 89,
	"./Bread.jpg": 90,
	"./Brownies & Blondies.jpg": 91,
	"./Brownies _ Blondies.jpg": 92,
	"./Butter.jpg": 93,
	"./Caramel.jpg": 94,
	"./Cheese.jpg": 95,
	"./Chocolate.jpg": 96,
	"./Citrus.jpg": 97,
	"./Coffee.jpg": 98,
	"./Cookies.jpg": 99,
	"./Cream & Pudding Cakes.jpg": 100,
	"./Cream & Pudding Cakes1.jpg": 101,
	"./Danish Dough.jpg": 102,
	"./Donut Sugar.jpg": 103,
	"./Egg Alternative.jpg": 104,
	"./Enhancer.jpg": 105,
	"./Herb.jpg": 106,
	"./Jelly Rolls.jpg": 107,
	"./Layer Cakes.jpg": 108,
	"./Maple.jpg": 109,
	"./Masker.jpg": 110,
	"./Milk.jpg": 111,
	"./Mousse & Cream Stabilizers.jpg": 112,
	"./Multigrain Bread.jpg": 113,
	"./Natural Colour.jpg": 114,
	"./No Bake Cheesecake.jpg": 115,
	"./Nut.jpg": 116,
	"./Orchard.jpg": 117,
	"./Pan Release.jpg": 118,
	"./Pancakes & Waffles.jpg": 119,
	"./Pastry Cream & Custard-min.jpg": 120,
	"./Pastry Cream & Custard.jpg": 121,
	"./Savory.jpg": 122,
	"./Shelf Life Extender.jpg": 123,
	"./Spice.jpg": 124,
	"./Sponge, Chiffon, & Angel Food Cakes.jpg": 125,
	"./Sweet Brown.jpg": 126,
	"./Sweet Dough.jpg": 127,
	"./Tropical.jpg": 128,
	"./Vanilla.jpg": 129,
	"./White Bread.jpg": 130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82;